import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";

import { useTheme } from "@mui/material/styles";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const ActivityModal = (theme) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  maxWidth: 600,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  borderRadius: "8px",
  [theme.breakpoints.down("sm")]: {
    width: "80%",
  },
  [theme.breakpoints.down("md")]: {
    width: "60%",
  },
  [theme.breakpoints.up("md")]: {
    width: "40%",
  },
});

const textareaContainerStyles = {
  display: "flex",
  flexDirection: "column",
  gap: "10px",
  width: "100%",
};

const textareaStyles = {
  flex: 1,
  width: "100%",
  padding: "10px",
  fontSize: "1rem",
  borderRadius: "4px",
  border: "1px solid lightgray",
  minHeight: "100px",
  boxSizing: "border-box",
  resize: "vertical",
  fontFamily: `"Oswald", "Helvetica", "Arial", sans-serif`,
};

const BasicModal = ({ ...props }) => {
  const theme = useTheme();

  return (
    <Modal
      open={props.open}
      onClose={props.handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={ActivityModal(theme)} style={{ border: "none" }}>
        <div className="dialogTitle">
          <Typography
            id="modal-modal-title"
            variant="h4"
            component="h2"
            style={{ fontWeight: "600", color: "#1ed6c9", fontSize: "14px" }}
          >
            Add Note
          </Typography>
          <IconButton onClick={props.handleClose}>
            <CloseIcon />
          </IconButton>
        </div>

        <div style={textareaContainerStyles}>
          {/* <Typography mt={3}>Add Note</Typography> */}
          <textarea
            className="responsive-textarea"
            maxLength="150"
            style={textareaStyles}
            id="w3review"
            name="w3review"
            rows="7"
            value={props.value}
            placeholder="Please enter a note that is 150 words long."
            onChange={props.onChange}
          ></textarea>
          {props.errText}
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "10px",
            marginTop: "10px",
          }}
        >
          <Button
            variant="contained"
            style={{
              backgroundColor: "#FB8C00",
              color: "#ffffff",
              fontWeight: "600",
            }}
            onClick={props.handleClose}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            style={{
              backgroundColor: "#4caf50",
              color: "#ffffff",
              fontWeight: "600",
            }}
            onClick={props.handleSave}
          >
            Save
          </Button>
        </div>
      </Box>
    </Modal>
  );
};

export default BasicModal;
